import {jQuery as $, lodash as _} from 'lib/shim';

import {Context} from 'context';
import {waitForRepaint} from '../../../javascript/util/dom';



const NAME = 'organism-filtered-download-list',
	SELECTOR = '.'+NAME;



class OrganismFilteredDownloadList {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$filterbox = this._$element.find('.filterbox').first();
			this._$listHeadline = this._$element.find('.list-headline');
			this._$downloadList = this._$element.find('.download-list').first();
			this._$downloadHolder = this._$downloadList.find('.teaser-holder').first();
			this._$showMoreButton = this._$downloadList.find('.cta').first().disable();

			this._downloadsInitialCount = $.isSet(this._$element.data('downloads-initial-count'))
				? this._$element.data('downloads-initial-count')
				: 12
			;
			this._downloadsShowMoreCount = $.isSet(this._$element.data('downloads-show-more-count'))
				? this._$element.data('downloads-show-more-count')
				: 12
			;
			this._headlineFilteredSingularTemplate = $.isSet(this._$element.data('headline-filtered-singular-template'))
				? this._$element.data('headline-filtered-singular-template')
				: 'Download ({count})'
			;
			this._headlineFilteredPluralTemplate = $.isSet(this._$element.data('headline-filtered-plural-template'))
				? this._$element.data('headline-filtered-plural-template')
				: 'Downloads ({count})'
			;

			this._downloadTemplate = this._$element.find('.download-template').html();
			this._downloadsUrl = this._$element.data('downloads-url');
			$.assert($.isSet(this._downloadsUrl, 'OrganismFilteredDownloadList.constructor | no downloads url has been provided'));
			this._downloadsJson = null;
			this._fittingDownloads = null;
			this._currentFilterTags = {};
			this._upperDownloadIndexShown = -1;

			this._prime();
		}

		return $element;
	}



	_prime(){
		$.getJSON(this._downloadsUrl, (downloadsJson) => {
			$.assert($.isArray(downloadsJson), 'OrganismFilteredDownloadList._prime | downloads json must be an array of objects');
			this._downloadsJson = downloadsJson;
			this._refreshFilterTags(this._downloadsJson);
			this._updateFilterbox(false, true);
			this._$element.removeClass('loading');
		});


		this._$filterbox.on('filterschanged.app', (e, data) => {
			let filters = data.filters;

			this._fittingDownloads = _.filter(this._downloadsJson, function(download){
				let res = true;

				_.each(filters, (filterValue, filterName) => {
					if(
						!$.isSet(download.filterAttributes)
						|| !$.isSet(download.filterAttributes[filterName])
						|| (!$.isSet(download.filterAttributes[filterName].value) && !$.isArray(download.filterAttributes[filterName].values))
						|| ((filterValue !== download.filterAttributes[filterName].value) && !_.includes(download.filterAttributes[filterName].values, filterValue))
					){
						res = false;
						return false;
					}
				});

				return res;
			});

			this._refreshFilterTags(this._fittingDownloads);
			this._updateFilterbox();
		});


		this._$filterbox.on('submitted.app', () => {
			let newUpperIndex = this._downloadsInitialCount - 1;

			this._$downloadHolder.empty();
			this._upperDownloadIndexShown = -1;
			this._showDownloads(newUpperIndex);

			this._$element.addClass('filtered');

			this._$listHeadline.text(
				$.strFormat(
					(_.size(this._fittingDownloads) === 1)
					? this._headlineFilteredSingularTemplate
					: this._headlineFilteredPluralTemplate,
					{count : _.size(this._fittingDownloads)}
				)
			);
		});


		this._$showMoreButton.on('click', (e) => {
			e.preventDefault();

			let newUpperIndex = this._upperDownloadIndexShown + this._downloadsShowMoreCount;

			this._showDownloads(newUpperIndex);
		});
	}



	_refreshFilterTags(downloads){
		this._currentFilterTags = {};

		let currentFilterTagsMap = {};

		_.each(downloads, (download) => {
			_.each(download.filterAttributes, (filterTag, filterName) => {
				if( !$.isSet(currentFilterTagsMap[filterName]) ){
					currentFilterTagsMap[filterName] = {
						values : [],
						textMap : {}
					};
				}

				if( $.isSet(filterTag.value, filterTag.text) ){
					currentFilterTagsMap[filterName].values.push(filterTag.value);
					currentFilterTagsMap[filterName].textMap[filterTag.value] = filterTag.text;
				}

				if( $.isArray(filterTag.values) && $.isArray(filterTag.texts) ){
					_.each(filterTag.values, (value, index) => {
						currentFilterTagsMap[filterName].values.push(value);
						currentFilterTagsMap[filterName].textMap[value] = filterTag.texts[index];
					});
				}
			});
		});

		_.each(currentFilterTagsMap, (map, filterName) => {
			_.each(_.uniq(map.values), (value) => {
				if( !$.isSet(this._currentFilterTags[filterName]) ){
					this._currentFilterTags[filterName] = [];
				}

				this._currentFilterTags[filterName].push({
					value : value,
					text : map.textMap[value]
				});
			});

			this._currentFilterTags[filterName] = _.sortBy(this._currentFilterTags[filterName], ['text']);
		});
	}



	_updateFilterbox(onlyCount, init){
		if( init ){
			this._$filterbox.triggerHandler('updatefilterdata.app', {
				mode : 'from-scratch',
				filters : this._currentFilterTags
			});
		} else if( onlyCount ){
			this._$filterbox.triggerHandler('updatefilterdata.app', {
				count : _.size(this._fittingDownloads)
			});
		} else {
			this._$filterbox.triggerHandler('updatefilterdata.app', {
				count : _.size(this._fittingDownloads),
				mode : 'from-scratch',
				filters : this._currentFilterTags
			});
		}
	}



	_showDownloads(newUpperIndex){
		let lastIndex = this._upperDownloadIndexShown;

		_.each(this._fittingDownloads, (download, index) => {
			if( index > this._upperDownloadIndexShown ){
				if( index > newUpperIndex ){
					return false;
				}

				let $newDownload = $($.strFormat(this._downloadTemplate, {
					url : download.url,
					image_alt : download.image.alt,
					image_desktop : download.image.sources.desktop,
					image_tablet : download.image.sources.tablet,
					image_mobile : download.image.sources.mobile,
					image_default : download.image.sources.default,
					subheadline : download.subheadline,
					headline : download.headline,
					copytext : download.copytext
				}));

				if( $.isEmpty(download.subheadline) ){
					$newDownload.find('.subheadline').remove();
				}

				if( $.isEmpty(download.copytext) ){
					$newDownload.find('.copytext').remove();
				}

				$newDownload.addClass('preparing');
				this._$downloadHolder.append($newDownload);
				waitForRepaint(() => {
					$newDownload.removeClass('preparing');
				});

				lastIndex = index;
			}
		});

		this._upperDownloadIndexShown = lastIndex;
		if( _.size(this._fittingDownloads) > this._upperDownloadIndexShown + 1 ){
			this._$showMoreButton.enable();
		} else {
			this._$showMoreButton.disable();
		}
	}

}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismFilteredDownloadList(app, $this));
	});

	return $elements;
}
